import {
  EmployeeSoftwareDetailsPageQueryDocument,
  SoftwareManagementDeleteEmployeeSoftwareMembershipDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

interface QueryParameters {
  id: string
  employeeId: string
  companyId: string
  dateFrom: string
  dateTo: string
  currency: string
}

export const useDeleteEmployeeSoftwareMembership = () => {
  const [deleteEmployeeSoftwareMembership, { loading }] = useMutation(
    SoftwareManagementDeleteEmployeeSoftwareMembershipDocument,
    {
      extractorFn: (data) =>
        data.softwareManagementMutations.deleteSoftwaremanagementEmployeeSoftwareMembership,
    }
  )

  return {
    delete(params: QueryParameters) {
      return deleteEmployeeSoftwareMembership({
        variables: { id: params.id },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: EmployeeSoftwareDetailsPageQueryDocument,
            variables: {
              companyId: params.companyId,
              employeeIds: [params.employeeId],
              dateFrom: params.dateFrom,
              dateTo: params.dateTo,
              currency: params.currency,
            },
          },
        ],
      })
    },
    loading,
  }
}
